export default __webpack_public_path__ + "static/media/Icon120.d863408b.jpg";